module.exports = __webpack_public_path__ + "img/backbeat-outline.108e8047.svg";